(() => {
  const card = document.getElementById('ng-email-signup');
  if (!card || card.dataset.initialized) return;
  card.dataset.initialized = 'true';
  const keys = { until: 'ng_signup_dismissed_until', subscribed: 'ng_signup_subscribed', visits: 'ng_signup_visits', path: 'ng_signup_last_path', pending: 'ng_signup_pending' };
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, String(value)); } catch {} };
  const result = card.querySelector('[data-ng-signup-result]');
  const form = card.querySelector('form');
  let stopped = false;
  let timer;
  const dismiss = () => {
    const hadFocus = card.contains(document.activeElement);
    card.hidden = true;
    stopped = true;
    clearTimeout(timer);
    write('localStorage', keys.until, Date.now() + 7 * 24 * 60 * 60 * 1000);
    if (hadFocus) {
      const main = document.getElementById('MainContent');
      if (main) {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
    }
  };
  card.querySelectorAll('[data-ng-signup-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !card.hidden) dismiss();
  });
  form.addEventListener('submit', () => write('sessionStorage', keys.pending, 'true'));
  if (result.dataset.success === 'true') {
    write('localStorage', keys.subscribed, 'true');
    if (read('sessionStorage', keys.pending) === 'true') card.hidden = false;
    write('sessionStorage', keys.pending, 'false');
    return;
  }
  if (result.dataset.error === 'true' && read('sessionStorage', keys.pending) === 'true') {
    card.hidden = false;
    return;
  }
  if (read('localStorage', keys.subscribed) === 'true' || Number(read('localStorage', keys.until)) > Date.now()) return;
  if (window.Shopify?.designMode) return;
  let visits = Number(read('sessionStorage', keys.visits)) || 0;
  if (read('sessionStorage', keys.path) !== location.pathname) {
    visits += 1;
    write('sessionStorage', keys.visits, visits);
    write('sessionStorage', keys.path, location.pathname);
  }
  const show = () => {
    if (stopped || read('localStorage', keys.subscribed) === 'true' || Number(read('localStorage', keys.until)) > Date.now()) return;
    const footer = document.querySelector('footer');
    const busy = [...document.querySelectorAll('video')].some(video => !video.paused && !video.ended) || document.hidden || document.querySelector('dialog[open], #ng-support-widget[open], .nc-header details[open]') || document.activeElement?.matches('input, textarea, select') || (footer && footer.getBoundingClientRect().top < innerHeight);
    if (busy) { timer = setTimeout(show, 5000); return; }
    card.hidden = false;
  };
  timer = setTimeout(show, visits >= 2 ? 10000 : 30000);
})();

